import {BaseModuleState} from "../../../infrastructure/models/base-module-state";

import {AthletePropositionBetModuleConfig} from "../athlete-proposition-bet-module.config";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {makeObservableClass} from "../../../infrastructure/decorators/observable";
import {PropositionBetsDetailsDataSource} from "../../../domain/bets/proposition-details/models/proposition-bets.details.data-source";
import {computed} from "mobx";
import {PropositionBetsRowViewModel} from "../../../domain/bets/proposition/models/row/proposition-bets.row.view-model";
import type {PropositionBetsDomainModel} from "../../../domain/bets/proposition/models/proposition-bets.domain-model";
import {PropositionBetsViewModel} from "../../../domain/bets/proposition/models/proposition-bets.view-model";
import {BookmakerViewModel} from "../../../domain/common/bookmaker/models/bookmaker-view-model";
import type {BookmakerDomainModel} from "../../../domain/common/bookmaker/models/bookmaker-domain-model";
import {GAME_STATUSES, THEME} from "../../../core/app/consts";

@makeObservableClass
export class AthletePropositionBetModuleState extends BaseModuleState {
  config: AthletePropositionBetModuleConfig;
  dataSource: PropositionBetsDetailsDataSource;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, AthletePropositionBetModuleConfig];

  get isPopulated() {
    return this.dataSource?.propositionBets || (this.props.propositionBets && this.props.game && this.props.bookmaker);
  }

  @computed get propositionBet() {
    const propositionBetDomainModel = this.props.propositionBets?.first() || this.dataSource.propositionBets?.first();
    const propositionBet: PropositionBetsDomainModel = propositionBetDomainModel ? new PropositionBetsViewModel(propositionBetDomainModel) : null;

    return propositionBet
  }

  @computed get row(): PropositionBetsRowViewModel {
    return this.propositionBet?.sections?.first()?.rows?.first();
  }

  @computed get title() {
    return this.propositionBet.name;
  }

  @computed get game(): String {
    return this.props.game || this.dataSource.games?.first()
  }

  @computed get statusGroup(): String {
    return this.game?.statusGroup;
  }

  @computed get isScheduled(): Boolean {
    return this.statusGroup === GAME_STATUSES.scheduled;
  }

  @computed get isLive(): Boolean {
    return this.statusGroup === GAME_STATUSES.started;
  }

  @computed get isEnded(): Boolean {
    return this.statusGroup === GAME_STATUSES.ended;
  }

  @computed get sportTypeId(): Number {
    const sportTypeId: Number = this.appState.context.sportType?.id;

    return sportTypeId;
  }
  @computed get isDarkMode(): Boolean {
    return this.appState.theme === THEME.DARK;
  }
  @computed get bookmaker(): BookmakerViewModel {
    let bookmaker = this.props.bookmaker
    if(!bookmaker) {
      const bookmakerDM: BookmakerDomainModel =  this.dataSource.bookmakers?.first();

      bookmaker = (bookmakerDM ? new BookmakerViewModel(bookmakerDM) : null)
    }

    return bookmaker
  }
}
